<mbs-modal
  [title]="'shared:modals.addDestinationBucket.detectIssues' | i18next"
  [isCustomModal]="true"
  #modal>
  <ng-container modal-body>
    <div>{{ 'shared:modals.addDestinationBucket.extensionsDescription' | i18next }}</div>

    <ul class="mt-2 mb-0 p-0 ml-4">
      <li *ngFor="let extension of extensions">{{ extension }}</li>
    </ul>

    @if (hasObjectLockWarning) {
      <div class="mt-4 mb-2">
        {{ 'shared:modals.immutability.objectLockChangesHaveBeenSaved' | i18next }}
      </div>

      <div class="mb-3">
        {{ 'shared:modals.immutability.toAvoidErrors' | i18next }}
      </div>

      <mbs-checkbox
        [label]="'shared:modals.immutability.objectLockChangesConfirmation' | i18next"
        [formControl]="confirmed"></mbs-checkbox>
    }
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="modal.save(true)">
      {{ 'shared:buttons.editDestination' | i18next }}
    </mbs-button>

    <mbs-button
      [type]="'secondary'"
      [disabled]="hasObjectLockWarning && !confirmed.value"
      (click)="modal.close()">
      {{ 'shared:buttons.confirm' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
